import React from "react";
import AppButton from "../../../components/common/appButton/AppButton";
import AppInput from "../../../components/common/appinput/AppInput";

const AdminAgency = ({
  data,
  updateData,
  onNext,
  onBack,
}) => {
  return (
    <div>

      <h1 className="font-['Playfair_Display'] text-[26px] font-medium leading-[1.08] tracking-[-0.025em] text-[#1f2318] sm:text-[34px]">
        Join as a{" "} Property Owner
        </h1>

      <p className="mt-2 text-[11px] text-[#9aa1a7]">
        Tell us about you and/or your company
      </p>


      <div className="mt-6 space-y-4">

        <AppInput
          label="Agency / Company Name"
          required
          name="agencyName"
          value={data.agencyName}
          onChange={(e) =>
            updateData({
              agencyName: e.target.value,
            })
          }
          placeholder="Whitfield Real Estate Group"
        />


        <AppInput
          label="Real Estate License No."
          required
          name="licenseNumber"
          value={data.licenseNumber}
          onChange={(e) =>
            updateData({
              licenseNumber: e.target.value,
            })
          }
          placeholder="DRE #00000000"
        />


        {/* <div className="grid grid-cols-2 gap-3">

          <SelectField
            label="Experience"
            value={data.experience}
            placeholder="Years"
            options={[
              "Less than 1 year",
              "1 - 3 years",
              "3 - 5 years",
              "5+ years",
              "10+ years",
            ]}
            onChange={(value) =>
              updateData({
                experience: value,
              })
            }
          />

          <SelectField
            label="Specialization"
            value={data.specialization}
            placeholder="Area"
            options={[
              "Residential",
              "Commercial",
              "Luxury",
              "Rentals",
              "Investment",
            ]}
            onChange={(value) =>
              updateData({
                specialization: value,
              })
            }
          />

        </div> */}


        {/* <div>

          <label className="mb-2 block text-[10px] font-semibold uppercase tracking-[0.08em] text-[#77818c]">
            Professional Bio
          </label>

          <textarea
            value={data.professionalBio}
            onChange={(e) =>
              updateData({
                professionalBio: e.target.value,
              })
            }
            placeholder="Describe your expertise and experience..."
            rows={4}
            className="
              w-full
              resize-none
              rounded-[9px]
              border
              border-[#e1e3e5]
              bg-white
              px-[15px]
              py-3
              text-[12px]
              text-[#1d3441]
              outline-none
              placeholder:text-[#a5adb5]
              focus:border-[#294d5d]
              focus:ring-4
              focus:ring-[#294d5d]/[0.08]
            "
          />

        </div> */}

      </div>


      <div className="mt-5 flex gap-3">

        <AppButton
          variant="secondary"
          onClick={onBack}
        >
          ← Back
        </AppButton>

        <AppButton onClick={onNext}>
          Continue →
        </AppButton>

      </div>

    </div>
  );
};


const SelectField = ({
  label,
  value,
  placeholder,
  options,
  onChange,
}) => {
  return (
    <div>

      <label className="mb-2 block text-[10px] font-semibold uppercase tracking-[0.08em] text-[#77818c]">
        {label}
      </label>

      <select
        value={value}
        onChange={(e) =>
          onChange(e.target.value)
        }
        className="
          h-[47px]
          w-full
          rounded-[9px]
          border
          border-[#e1e3e5]
          bg-white
          px-3
          text-[12px]
          text-[#1d3441]
          outline-none
          focus:border-[#294d5d]
        "
      >

        <option value="">
          {placeholder}
        </option>

        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}

      </select>

    </div>
  );
};

export default AdminAgency;